import { Link, useLocation } from "react-router-dom";
import { Phone, Mail } from "lucide-react";

const LOGO_URL_SAGE =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_grounded-wellness-3/artifacts/etbi1b2r_Untitled%20design.png";
const LOGO_URL_PURPLE =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_grounded-wellness-3/artifacts/lr6iybd4_Untitled%20design.png";

const Footer = () => {
  const location = useLocation();
  const isTantric = location.pathname === "/intimacy-tantra";
  const logoUrl = isTantric ? LOGO_URL_PURPLE : LOGO_URL_SAGE;
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#E8E5DF] bg-[#F4F1ED] mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-6">
            <img
              src={logoUrl}
              alt="Shakti Yogini Sri Yantra logo"
              className="w-12 h-12 rounded-full object-contain"
              data-testid="footer-logo-image"
            />
            <span className="font-serif text-2xl text-[#2D3A2B]">
              Shakti Yogini
            </span>
          </div>
          <p className="font-serif text-2xl md:text-3xl text-[#2D3A2B] leading-relaxed max-w-md">
            A sanctuary for healing — where clinical care meets the quiet
            wisdom of the body.
          </p>
          <p className="mt-6 text-sm text-[#4A5D46]">
            Certified Yoga Therapy with Marissa Rajpaul. A mobile practice
            based in Coquitlam — serving the Vancouver Lower Mainland and
            available internationally.
          </p>
        </div>

        <div>
          <h4 className="font-serif text-lg text-[#2D3A2B] mb-4">Explore</h4>
          <ul className="space-y-3 text-sm">
            <li>
              <Link
                to="/"
                data-testid="footer-link-home"
                className="text-[#4A5D46] hover:text-[#2D3A2B] transition-colors"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                data-testid="footer-link-services"
                className="text-[#4A5D46] hover:text-[#2D3A2B] transition-colors"
              >
                Yoga Therapy
              </Link>
            </li>
            <li>
              <Link
                to="/pricing"
                data-testid="footer-link-pricing"
                className="text-[#4A5D46] hover:text-[#2D3A2B] transition-colors"
              >
                Investment
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                data-testid="footer-link-contact"
                className="text-[#4A5D46] hover:text-[#2D3A2B] transition-colors"
              >
                Contact & Booking
              </Link>
            </li>
            <li className="pt-3 border-t border-[#E0DCD3] mt-3">
              <Link
                to="/intimacy-tantra"
                data-testid="footer-link-tantric"
                className="text-[#7B8E76] hover:text-[#4A5D46] text-xs tracking-wide transition-colors italic"
              >
                Intimacy & Tantric Exploration
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg text-[#2D3A2B] mb-4">Reach Out</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2 text-[#4A5D46]">
              <Phone className="w-4 h-4" aria-hidden />
              <a
                href="tel:+12048990166"
                data-testid="footer-phone"
                className="hover:text-[#2D3A2B]"
              >
                204-899-0166
              </a>
            </li>
            <li className="flex items-center gap-2 text-[#4A5D46]">
              <Mail className="w-4 h-4" aria-hidden />
              <a
                href="mailto:shaktiyogini.marketing@gmail.com"
                data-testid="footer-email"
                className="hover:text-[#2D3A2B] break-all"
              >
                shaktiyogini.marketing@gmail.com
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E0DCD3]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 text-xs text-[#7B8E76]">
          <p>© {new Date().getFullYear()} Shakti Yogini. All rights reserved.</p>
          <p className="italic">
            Coquitlam · Vancouver Lower Mainland · Available Internationally
          </p>
          <p data-testid="footer-credit">
            Site by{" "}
            <a
              href="https://www.sebastianvisualcorp.ca"
              target="_blank"
              rel="noopener noreferrer"
              className="underline underline-offset-4 decoration-[#C6BFB4] hover:text-[#2D3A2B] hover:decoration-[#8A9A83] transition-colors"
              data-testid="footer-credit-link"
            >
              Sebastian Visual Corp
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
